/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Source_GcInputs */

const en_gc_resources_compare_source_gc = /** @type {(inputs: Gc_Resources_Compare_Source_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft source`)
};

const zh_gc_resources_compare_source_gc = /** @type {(inputs: Gc_Resources_Compare_Source_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft 源码`)
};

/**
* | output |
* | --- |
* | "GridCraft source" |
*
* @param {Gc_Resources_Compare_Source_GcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_source_gc = /** @type {((inputs?: Gc_Resources_Compare_Source_GcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Source_GcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_source_gc(inputs)
	return zh_gc_resources_compare_source_gc(inputs)
});
export { gc_resources_compare_source_gc as "gc.resources.compare.source_gc" }